<template>
  <div class="exhibitionCatalog">
    <div v-if="exhibitionCatalog.title">
      <h3 class="title" title="Titre, ville, année d'édition du catalogue">
        {{exhibitionCatalog.title}}, {{exhibitionCatalog.city}}
        <span v-if="exhibitionCatalog.publishing_year">, {{exhibitionCatalog.publishing_year}}</span>
        <el-button
          @click="exportCatalog"
          size="small"
          v-loading="exporting"
        >
          {{$t('pages.results.exportCsv')}}
        </el-button>
      </h3>

      <CatalogDates :catalog="exhibitionCatalog" />
      <div v-if="exhibitionCatalog.source_catalog">
        {{$t('pages.results.source_catalog_lower')}} : <cite>{{exhibitionCatalog.source_catalog}}</cite>
      </div>
      <cite v-if="exhibitionCatalog.contributor">
        {{$t('pages.results.filledBy')}}
        <span>{{ exhibitionCatalog.contributor }}.</span>
      </cite>

      <div>
        <p><b>
            <span v-if="exhibitionCatalog.sections">{{exhibitionCatalog.sections.length}}</span>
            <span v-else>0</span>
            section<span v-if="exhibitionCatalog.sections.length > 1">s</span>
        </b></p>

        <ul
          v-if="exhibitionCatalog.sections"
          v-for="section in exhibitionCatalog.sections"
          v-loading="exhibitionCatalog.loading"
          :key="section.id"
        >
          <li>
            <span v-if="section.nb_exhibitor > 0" @click="openSectionDialog(section)" class="section" role=”link”>
              <span :title="$t('pages.results.sectionTitle')"><strong>{{section.exhibition_section_title || section.exhibition_catalog_title || $t('pages.results.noSection')}}</strong> - </span>
              <span v-if="section.address" :title="$t('pages.results.sectionAddress')">{{section.address}} - </span>
              {{$t('pages.results.exhibitors')}} : {{section.nb_exhibitor !== 0 ? section.nb_exhibitor : $t('pages.results.unknown')}} -
              {{$t('pages.results.exhibitedWorks')}} : {{section.nb_exhibited_work !== 0 ? section.nb_exhibited_work : $t('pages.results.unknown')}}
            </span>
            <span v-if="section.nb_exhibitor === 0 && section.nb_exhibited_work === 0">
              <span v-if="section.exhibition_section_title" :title="$t('pages.results.sectionTitle')"><strong>{{section.exhibition_section_title}}</strong> - </span>
              <span v-if="section.address" :title="$t('pages.results.sectionAddress')">{{section.address}} - </span>
              {{$t('pages.results.exhibitors')}} : {{section.nb_exhibitor !== 0 ? section.nb_exhibitor : $t('pages.results.unknown')}} -
              {{$t('pages.results.exhibitedWorks')}} : {{section.nb_exhibited_work !== 0 ? section.nb_exhibited_work : $t('pages.results.unknown')}}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="exhibitionCatalog.title === null">
      <h3 class="title">
        {{$t('pages.results.catalogUnknown')}}
      </h3>
    </div>

  </div>
</template>

<script>
import { Button } from 'element-ui'
import {
  OPEN_SECTION_DIALOG,
  GET_EXHIBITOR_DETAIL
} from '../../store/dialog/actions'
import { EXHIBITED_WORK } from '@/services/filters'
import { exportCSV } from '@/services/export'

import CatalogDates from '../Catalog/CatalogDates'
export default {
  name: 'exhibitionCatalog',
  props: ['exhibitionCatalog'],
  data: function () {
    return {
      exporting: false
    }
  },
  methods: {
    openSectionDialog (section) {
      this.$store.dispatch('dialog/' + OPEN_SECTION_DIALOG, {
        section
      })

      this.$set(section, 'exhibitors', {})
      this.$store.dispatch('dialog/' + GET_EXHIBITOR_DETAIL, {
        sectionId: section.id,
        objectToIncrement: section.exhibitors
      })
    },
    async exportCatalog () {
      this.exporting = true
      await exportCSV(EXHIBITED_WORK, {
        filters: `[
          {
            "property":"id_catalog",
            "matchType":"eq",
            "value":"${this.exhibitionCatalog.id_exhibition_catalog}"
          }
        ]`
      })
      this.exporting = false
    }
  },
  components: {
    CatalogDates,
    elButton: Button
  }
}
</script>
<style>
.exhibitionCatalog {
  margin-bottom: 1rem;
  font-size: .75rem;
  color: #1f2d3d;
}
.exhibitionCatalog .section {
  color: #23a6b9;
}

.exhibitionCatalog .section:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExhibitionCatalog/ExhibitionCatalog.vue